import addSchedulePointTemplate from './../add-schedule-point/add-schedule-point.html';
import template from './step-4.html';

class StepFourthComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    SchedulePointService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.SchedulePointService = SchedulePointService;
    this.schedulePoints = [];
  }

  $onInit() {
    this.getAllSchedulePoints();
  }

  addSchedulePoint(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddSchedulePointController',
      template: addSchedulePointTemplate,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(() => {
        this.getAllSchedulePoints();
      }, () => {});
  }

  getAllSchedulePoints() {
    this.SchedulePointService.getAll(true).then(result => {
      this.schedulePoints = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać planu zajęć')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  removeSchedulePoint(schedulePointId, ev) {
    ev.stopPropagation();
    this.SchedulePointService.delete(schedulePointId).then(() => {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Pomyślnie usunięto element')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(({MessagePL}) => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(MessagePL)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}

export const StepFourth = {
  template,
  controller: StepFourthComponent
};
